import { IRootState } from '../../../../store'
import { ICardiacState } from '../store/cardiac.types'

export const getCardiacSelector = (state: IRootState): ICardiacState => state.cardiac
